import { Component, effect, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'oes-cell-comment-clipboard',
  templateUrl: './cell-content-clipboard.component.html',
  styleUrls: ['./cell-content-clipboard.component.scss']
})
export class CellContentClipboardComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  value: string;

  copied = signal<boolean>(false);

  constructor() {
    effect(() => {
      // Clears the copied state after 2 seconds
      if (this.copied()) {
        setTimeout(() => this.copied.set(false), 2000);
      }
    });
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value || '';
  }

  refresh(): boolean {
    return false;
  }

  copyToClipboard(): void {
    if (this.value) {
      navigator.clipboard.writeText(this.value)
        .then(() => this.copied.set(true))
        .catch(() => this._fallbackCopyToClipboard(this.value));
    }
  }

  private _fallbackCopyToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
}
